export default "/images/vendor/flag-icon-css/flags/1x1/bb.svg?901de8a417306b83d2522cbfc0822f2e";